module.exports = __webpack_public_path__ + "img/SU3M10_new.ec4ed245.jpg";